import { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer'
import StorySection2 from '../../components/StorySection2/StorySection2';
import Scrollbar from '../../components/scrollbar/scrollbar'
import PartnerSection from '../../components/PartnerSection';

const StoryPage2: React.FC = () => {
    
    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-1'}/>
            <PageTitle pageTitle={'Our Story'} pagesub={'Story'} />
            <StorySection2 sClass={'section-padding'}/>
            <PartnerSection pClass={'section-padding pt-0'}/>
            <Footer/>
            <Scrollbar />
        </Fragment>
    )
};

export default StoryPage2;
